import { File, LogOut, Mail, Settings, User } from "react-feather";

export const PROFILE = [
  {
    icon: <User />,
    title: "Account",
    url: `${process.env.PUBLIC_URL}/users/user-profile`,
  },
  {
    icon: <Mail />,
    title: "Inbox",
    url: `${process.env.PUBLIC_URL}/email/email-app`,
  },
  {
    icon: <File />,
    title: "Taskboard",
    url: `${process.env.PUBLIC_URL}/task`,
  },
  {
    icon: <Settings />,
    title: "Settings",
    url: `${process.env.PUBLIC_URL}/users/edit-profile`,
  },
  {
    icon: <LogOut />,
    title: "Log out",
    url: `${process.env.PUBLIC_URL}/login`,
  },
];
